import {AppRoute} from "./enum";
import {Type} from "../../redux/Transaction/helper";
import TransactionProvider from "../../components/Providers/TransactionProvider";

export function getWrapper(routeId) {
    switch (routeId) {
        case AppRoute.SalesQuotationsNew:
        case AppRoute.SalesQuotationsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_quote },
            };
        case AppRoute.SalesOrdersNew:
        case AppRoute.SalesOrdersView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_order },
            };
        case AppRoute.SalesDeliveryOrdersNew:
        case AppRoute.SalesDeliveryOrdersView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_delivery_order },
            };
        case AppRoute.SalesInvoicesNew:
        case AppRoute.SalesInvoicesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_invoice },
            };
        case AppRoute.SalesCreditNotesNew:
        case AppRoute.SalesCreditNotesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_credit_note },
            };
        case AppRoute.SalesPaymentsNew:
        case AppRoute.SalesPaymentsModeView:
        case AppRoute.SalesPaymentsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_payment },
            };
        case AppRoute.SalesRefundsNew:
        case AppRoute.SalesRefundsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.sale_refund },
            };
        case AppRoute.PurchasesOrdersNew:
        case AppRoute.PurchasesOrdersBatch:
        case AppRoute.PurchasesOrdersView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_order },
            };
        case AppRoute.PurchasesGoodsReceivedNotesNew:
        case AppRoute.PurchasesGoodsReceivedNotesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_goods_received_note },
            };
        case AppRoute.PurchasesBillsNew:
        case AppRoute.PurchasesBillsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_bill },
            };
        case AppRoute.PurchasesCreditNotesNew:
        case AppRoute.PurchasesCreditNotesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_credit_note },
            };
        case AppRoute.PurchasesPaymentsNew:
        case AppRoute.PurchasesPaymentsModeView:
        case AppRoute.PurchasesPaymentsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_payment },
            };
        case AppRoute.PurchasesRefundsNew:
        case AppRoute.PurchasesRefundsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.purchase_refund },

            };
        case AppRoute.BankIncomesNew:
        case AppRoute.BankIncomesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.bank_income },
            };
        case AppRoute.BankExpensesNew:
        case AppRoute.BankExpensesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.bank_expense },
            };
        case AppRoute.BankTransfersNew:
        case AppRoute.BankTransfersView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.bank_transfer },
            };
        case AppRoute.StockAdjustmentsNew:
        case AppRoute.StockAdjustmentsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.stock_adjustment },
            };
        case AppRoute.StockTransfersNew:
        case AppRoute.StockTransfersView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.stock_transfer },
            };
        case AppRoute.AccountingJournalEntriesNew:
        case AppRoute.AccountingJournalEntriesBatch:
        case AppRoute.AccountingJournalEntriesPayroll:
        case AppRoute.AccountingJournalEntriesView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.journal_entry },
            };
        case AppRoute.AccountingContrasNew:
        case AppRoute.AccountingContrasView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.contra },
            };
        case AppRoute.AccountingDeemedPaymentsNew:
        case AppRoute.AccountingDeemedPaymentsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { transactionType: Type.tax_deemed_payment },
            };
        case AppRoute.InstructionsNew:
        case AppRoute.InstructionsView:
            return {
                wrapper: TransactionProvider,
                wrapperProps: { isRecurring: true },
            };
        default:
            return {};
    }
}
